import { CMS_RESPONSE } from '../mock/cms.mock';
import { getProperty } from './../../shared/utils/getProperty';

export class FooterModel {
  public footer: string;
  public legal: string;

  constructor(model: any) {
    this.footer = getProperty(
      model,
      'components._onboardingcmc_componente_footer._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_footer
        ._onboardingpf_componente_item_description
    );

    this.legal = getProperty(
      model,
      'components._onboardingcmc_componente_legal._onboardingpf_componente_item_description',
      CMS_RESPONSE.components._onboardingcmc_componente_legal
        ._onboardingpf_componente_item_description
    );
  }
}
